<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="ليلى">
<h1><span dir="rtl">ليلى</span></h1>
<p style="text-indent:00em"><span dir="rtl">ليلى..</span></p>
<p style="text-indent:00em"><span dir="rtl">عمانيَّة الجنسيَّة، حاصلة على شهادة الماجستير في المحاسبة وريادة الأعمال في جامعة بيدفود</span> <span dir="rtl">شاير بالمملكة المتحدة.</span></p>
<p style="text-indent:00em"><span dir="rtl">تتَّسِم بخيال جامح وعشق لا حدودَ له للقلم.</span></p>
<p style="text-indent:00em"><span dir="rtl">روايتها هذه هي أوَّل أعمالها للنشر.</span></p>
<p style="text-indent:00em"><span dir="rtl">
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?64338694